// extracted by mini-css-extract-plugin
export var danger = "_3t-6";
export var lightPink = "_3t-a";
export var medium = "_3t-j";
export var nearSquare = "_3t-m";
export var neutralBlue = "_3t-8";
export var neutralYellow = "_3t-7";
export var noCapitalize = "_3t-1";
export var normal = "_3t-2";
export var pill = "_3t-0";
export var primary = "_3t-3";
export var primaryLight = "_3t-4";
export var shadow = "_3t-n";
export var small = "_3t-k";
export var solidBlack = "_3t-i";
export var solidGreen = "_3t-d";
export var solidLightBlue = "_3t-f";
export var solidNavy = "_3t-e";
export var solidOrange = "_3t-h";
export var solidPink = "_3t-g";
export var solidRed = "_3t-b";
export var solidWhite = "_3t-9";
export var solidYellow = "_3t-c";
export var success = "_3t-5";
export var xsmall = "_3t-l";